import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth' // 验权
import Utils from '@/utils/utils';
router.beforeEach((to, from, next) => {
    if (getToken()) {
      next()
      // if (store.getters.permissions.length === 0) {
      //   store.dispatch('GetInfo').then(res => { // 拉取用户信息
      //     const permissions = res.data.permissions // note: permissions must be a array! such as: ['editor','develop']
      //     store.dispatch('GenerateRoutes', { permissions }).then(() => { // 根据permissions权限生成可访问的路由表
      //       router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
      //       next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
      //     })
      //   }).catch((err) => {
      //     store.dispatch('FedLogOut').then(() => {
      //       Message.error(err || '登录信息失效，请重新登录')
      //       Utils.$emit('isok',1);
      //     })
      //   })
      // } else {
      //   next()
      // }
      if(!store.getters.getUserInfo.student_id){
        Utils.$emit('isok',2);
      }
    } else {
      next()
      if(to.path !== '/forum/list'){
        Utils.$emit('isok',1);
      }
    } 
})
// const whiteList = ['/login','/upload'] // 不重定向白名单
// router.beforeEach((to, from, next) => {
//   NProgress.start()
//   if (getToken()) {
//       next()
//     // if (to.path === '/login') {
//     //   next({ path: '/' })
//     //   NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
//     // } else {
//       if (store.getters.permissions.length === 0) {
//         store.dispatch('GetInfo').then(res => { // 拉取用户信息
//           const permissions = res.data.permissions // note: permissions must be a array! such as: ['editor','develop']
//           store.dispatch('GenerateRoutes', { permissions }).then(() => { // 根据permissions权限生成可访问的路由表
//             router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
//             next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
//           })
//         }).catch((err) => {
//           store.dispatch('FedLogOut').then(() => {
//             Message.error(err || '登录信息失效，请重新登录')
//             next({ path: '/' })
//           })
//         })
//       } else {
//         next()
//       // }
//     }
//   } else {
//     if (whiteList.indexOf(to.path) !== -1) {
//       next()
//     } else {
//       // next('/login')
//       NProgress.done()
//     }
//   }
// })

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
